import React from 'react';
import { useNavigate } from 'react-router-dom';
import fondpropos1 from '../fondpropos1.png';
import fondpropos2 from '../fondpropos2.png';
import { FaUser, FaShieldAlt, FaHeart, FaUsers, FaLock, FaCheck, FaMedal, FaBoxOpen } from 'react-icons/fa';
import { BsHeart, BsPeople, BsBook, BsBagCheck } from "react-icons/bs";
import { GrShield } from "react-icons/gr";
import { RiChatHeartLine } from "react-icons/ri";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useResponsive } from '../hooks/useResponsive';
import { useAuth } from '../context/AuthContext';
import NavbarAuth from '../components/NavbarAuth';

const About = () => {
    const { user } = useAuth();

    const navigate = useNavigate();
    const { isSmall: isSmallMobile, isMobile, windowWidth } = useResponsive();
    const isTablet = windowWidth > 768 && windowWidth <= 1024;

    return (
        <div style={styles.container}>

            {/* ═══════════ NAVBAR ═══════════ */}
            {user ? <NavbarAuth /> : <Navbar />}

            {/* ═══════════ HERO ═══════════ */}
            <section style={{
                position: 'relative',
                overflow: 'hidden',
                minHeight: isSmallMobile ? '300px' : isMobile ? '360px' : isTablet ? '400px' : '480px',
                backgroundColor: '#fff',
            }}>
                {!isMobile && (
                    <>
                        <img src={fondpropos1} alt="" style={{
                            position: 'absolute',
                            top: 0, left: 0,
                            width: '100%', height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center top',
                            display: 'block',
                        }} />
                        <div style={{ position: 'absolute', inset: 0 }} />
                    </>
                )}
                {isMobile && (
                    <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(255,255,255,0.95)' }} />
                )}
                <div style={{
                    position: 'relative', zIndex: 2,
                    maxWidth: isMobile ? '100%' : isTablet ? '65%' : '52%',
                    padding: isSmallMobile ? '32px 16px' : isMobile ? '48px 24px' : isTablet ? '52px 40px' : '80px 64px',
                    display: 'flex', flexDirection: 'column',
                    alignItems: isMobile ? 'center' : 'flex-start',
                    textAlign: isMobile ? 'center' : 'left',
                }}>
                    <p style={{ color: '#781840', fontSize: isSmallMobile ? '10px' : '11px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '16px', marginTop: 0 }}>
                        À PROPOS DE NOUS
                    </p>
                    <h1 style={{ color: '#1a0010', fontWeight: '700', fontSize: isSmallMobile ? '26px' : isMobile ? '32px' : isTablet ? '38px' : '48px', lineHeight: '1.2', marginBottom: '0', marginTop: 0 }}>
                        Zawaj <span style={{ color: '#781840' }}>&</span> Tawadud,
                    </h1>
                    <h1 style={{ color: '#781840', fontWeight: '700', fontSize: isSmallMobile ? '22px' : isMobile ? '28px' : isTablet ? '32px' : '44px', lineHeight: '1.2', marginBottom: '16px', marginTop: 0 }}>
                        plus qu'une plateforme,<br />une mission.
                    </h1>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '24px' }}>
                        <div style={{ width: '32px', height: '2px', backgroundColor: '#781840' }} />
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                        <div style={{ width: '32px', height: '2px', backgroundColor: '#781840' }} />
                    </div>
                    <p style={{ color: '#555', lineHeight: '1.8', fontSize: isSmallMobile ? '13px' : '14px', marginBottom: '16px', maxWidth: isMobile ? '100%' : '420px' }}>
                        Zawaj & Tawadud est une plateforme de mise en relation sérieuse et éthique, créée pour aider les musulmans à trouver un conjoint qui partage leurs valeurs et leur vision de la vie.
                    </p>
                    <p style={{ color: '#555', lineHeight: '1.8', fontSize: isSmallMobile ? '13px' : '14px', margin: 0, maxWidth: isMobile ? '100%' : '420px' }}>
                        Nous croyons qu'un mariage réussi repose sur la sincérité, la bienveillance et la recherche de l'agrément d'Allah.
                    </p>
                </div>
            </section>

            {/* ═══════════ MISSION & VALEURS ═══════════ */}
            <section style={{ backgroundColor: '#fdf8fa', padding: isSmallMobile ? '32px 12px' : isMobile ? '40px 16px' : isTablet ? '48px 20px' : '64px 24px' }}>
                <div style={{
                    maxWidth: '1200px', margin: '0 auto',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: '24px',
                    alignItems: 'flex-start',
                }}>
                    {/* Notre Mission */}
                    <div style={{ flex: 1, backgroundColor: 'white', borderRadius: '16px', padding: isSmallMobile ? '20px' : isMobile ? '24px' : '32px', border: '1px solid #f0dde6', boxShadow: '0 2px 16px rgba(192,48,106,0.06)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                            <div style={{ width: '40px', height: '40px', borderRadius: '10px', border: '1px solid #f0dde6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <FaBoxOpen color="#781840" size={18} />
                            </div>
                            <p style={{ color: '#781840', fontSize: '11px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', margin: 0 }}>NOTRE MISSION</p>
                        </div>
                        <h2 style={{ color: '#1a0010', fontSize: isSmallMobile ? '18px' : isMobile ? '20px' : isTablet ? '22px' : '24px', fontWeight: '700', lineHeight: '1.4', marginBottom: '16px', marginTop: 0 }}>
                            Faciliter des unions bénies fondées sur des valeurs solides
                        </h2>
                        <p style={{ color: '#666', fontSize: isSmallMobile ? '12px' : '13px', lineHeight: '1.8', marginBottom: '20px' }}>
                            Notre mission est de créer un environnement sécurisé et respectueux, où chaque membre peut chercher l'âme sœur en toute sérénité, dans le respect des principes islamiques.
                        </p>
                        {[
                            'Encourager des rencontres sérieuses et sincères',
                            'Promouvoir des valeurs islamiques authentiques',
                            'Construire des foyers musulmans épanouis',
                        ].map((item, i) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                                <FaCheck color="#781840" size={12} style={{ flexShrink: 0 }} />
                                <span style={{ color: '#555', fontSize: isSmallMobile ? '12px' : '13px' }}>{item}</span>
                            </div>
                        ))}
                    </div>

                    {/* Nos Valeurs */}
                    <div style={{ flex: 1.2 }}>
                        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                            <p style={{ color: '#1a0010', fontSize: isSmallMobile ? '16px' : isMobile ? '18px' : '22px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', margin: '0 0 8px 0' }}>NOS VALEURS</p>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                                <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                                <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                                <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: isSmallMobile ? '1fr' : '1fr 1fr', gap: '16px' }}>
                            {[
                                { icon: <GrShield size={22} color="white" />, title: 'Sincérité', text: "Nous encourageons l'honnêteté et la transparence dans chaque démarche." },
                                { icon: <BsHeart size={22} color="white" />, title: 'Respect', text: 'Chaque membre est traité avec dignité et bienveillance.' },
                                { icon: <FaLock size={22} color="white" />, title: 'Confidentialité', text: 'Vos données sont protégées et jamais partagées.' },
                                { icon: <BsBook size={22} color="white" />, title: 'Éthique islamique', text: "Nos pratiques sont conformes aux enseignements de l'Islam." },
                            ].map((v, i) => (
                                <div key={i} style={{ backgroundColor: 'white', borderRadius: '14px', padding: isSmallMobile ? '16px' : '20px', border: '1px solid #f0dde6', boxShadow: '0 2px 12px rgba(192,48,106,0.06)', display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                                    <div style={{ width: '44px', height: '44px', borderRadius: '50%', backgroundColor: '#4a0028', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        {v.icon}
                                    </div>
                                    <div>
                                        <h4 style={{ color: '#1a0010', fontSize: isSmallMobile ? '13px' : '14px', fontWeight: '700', marginBottom: '6px', marginTop: 0 }}>{v.title}</h4>
                                        <p style={{ color: '#aaa', fontSize: isSmallMobile ? '11px' : '12px', lineHeight: '1.6', margin: 0 }}>{v.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══════════ STATS ═══════════ */}
            <section style={{ backgroundColor: '#fdf8fa', padding: isSmallMobile ? '0 12px 32px' : isMobile ? '0 16px 40px' : isTablet ? '0 20px 40px' : '0 24px 48px' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', backgroundColor: '#4a0028', borderRadius: '16px', padding: isSmallMobile ? '20px 12px' : isMobile ? '24px 16px' : isTablet ? '28px 32px' : '32px 48px' }}>
                    <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                        <h2 style={{ color: 'white', fontSize: isSmallMobile ? '18px' : isMobile ? '20px' : isTablet ? '22px' : '26px', fontWeight: '700', margin: '0 0 10px 0' }}>
                            Zawaj & Tawadud en chiffres
                        </h2>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                            <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                            <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                        </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)' }}>
                        {[
                            { icon: <FaUsers size={isMobile ? 18 : 24} color="white" />, num: '500+', lbl: 'Membres inscrits' },
                            { icon: <FaShieldAlt size={isMobile ? 18 : 24} color="white" />, num: '300+', lbl: 'Profils vérifiés' },
                            { icon: <FaHeart size={isMobile ? 18 : 24} color="white" />, num: '6', lbl: 'Mariages facilités' },
                            { icon: <FaMedal size={isMobile ? 18 : 24} color="white" />, num: '100%', lbl: "Conforme à l'éthique islamique" },
                        ].map((s, i) => (
                            <div key={i} style={{
                                display: 'flex', alignItems: 'center', gap: isSmallMobile ? '8px' : '14px',
                                justifyContent: 'flex-start',
                                padding: isSmallMobile ? '12px 6px 12px 18px' : isMobile ? '16px 8px 16px 24px' : '16px 24px',
                                borderRight: isMobile && i % 2 === 0 ? '1px solid rgba(255,255,255,0.08)' : !isMobile && i < 3 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                                borderBottom: isMobile && i < 2 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                            }}>
                                <div style={{ flexShrink: 0, width: isMobile ? '18px' : '24px', display: 'flex', justifyContent: 'center' }}>{s.icon}</div>
                                <div>
                                    <div style={{ color: 'white', fontSize: isSmallMobile ? '16px' : isMobile ? '20px' : isTablet ? '22px' : '26px', fontWeight: '700' }}>{s.num}</div>
                                    <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: isSmallMobile ? '10px' : isMobile ? '11px' : '13px' }}>{s.lbl}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══════════ POURQUOI CHOISIR ═══════════ */}
            <section style={{ backgroundColor: '#fff', padding: isSmallMobile ? '32px 12px' : isMobile ? '40px 20px' : isTablet ? '48px 20px' : '64px 24px', textAlign: 'center' }}>
                <h2 style={{ color: '#1a0010', fontSize: isSmallMobile ? '20px' : isMobile ? '24px' : isTablet ? '28px' : '32px', fontWeight: '700', marginBottom: '10px', marginTop: 0 }}>
                    Pourquoi choisir Zawaj & Tawadud ?
                </h2>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: isSmallMobile ? '24px' : '40px' }}>
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                </div>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isSmallMobile ? '1fr 1fr' : isMobile ? '1fr 1fr' : isTablet ? 'repeat(3, 1fr)' : 'repeat(5, 1fr)',
                    maxWidth: '1200px', margin: '0 auto', gap: isSmallMobile ? '12px' : '16px',
                }}>
                    {[
                        { icon: <BsPeople size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Profils authentiques', text: 'Vérification manuelle pour des profils fiables et sérieux.' },
                        { icon: <BsBagCheck size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Sécurité maximale', text: 'Vos informations sont protégées par des technologies avancées.' },
                        { icon: <RiChatHeartLine size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Accompagnement', text: 'Des conseillers et ressources pour vous guider dans votre démarche.' },
                        { icon: <GrShield size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Conformité islamique', text: 'Une démarche respectueuse des principes et des valeurs islamiques.' },
                        { icon: <BsHeart size={isSmallMobile ? 22 : 28} color="#781840" />, title: 'Bienveillance', text: 'Une communauté basée sur le respect et la bonne intention.' },
                    ].map((f, i) => (
                        <div key={i} style={{ padding: isSmallMobile ? '16px 8px' : '24px 16px', textAlign: 'center' }}>
                            <div style={{
                                width: isSmallMobile ? '48px' : '60px',
                                height: isSmallMobile ? '48px' : '60px',
                                border: '1px solid #f0dde6', borderRadius: '50%',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                margin: '0 auto 14px',
                                boxShadow: '0 2px 12px rgba(192,48,106,0.08)',
                            }}>
                                {f.icon}
                            </div>
                            <h4 style={{ color: '#1a0010', fontSize: isSmallMobile ? '12px' : '14px', fontWeight: '700', marginBottom: '8px', marginTop: 0 }}>{f.title}</h4>
                            <p style={{ color: '#aaa', fontSize: isSmallMobile ? '11px' : '12px', lineHeight: '1.7', margin: 0 }}>{f.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ═══════════ CTA ═══════════ */}
            <section style={{
                margin: isSmallMobile ? '0 8px 0' : isMobile ? '0 12px 0' : isTablet ? '0 16px 10px' : '0 24px 10px',
                borderRadius: '20px', overflow: 'hidden', position: 'relative',
                backgroundImage: `url(${fondpropos2})`,
                backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat',
            }}>
                <div style={{ position: 'absolute', inset: 0 }} />
                <div style={{
                    position: 'relative', zIndex: 2,
                    display: 'flex', flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '24px' : isTablet ? '32px' : '48px',
                    maxWidth: isTablet ? '90%' : '750px',
                    margin: '0 auto',
                    padding: isSmallMobile ? '32px 16px' : isMobile ? '48px 20px' : isTablet ? '48px 28px' : '56px 28px',
                    alignItems: 'center',
                }}>
                    <div style={{ flex: 1, textAlign: isMobile ? 'center' : 'left' }}>
                        <h2 style={{ color: 'black', fontSize: isSmallMobile ? '18px' : isMobile ? '22px' : isTablet ? '24px' : '30px', fontWeight: '700', lineHeight: '1.4', marginBottom: '12px', marginTop: 0 }}>
                            Prêt à commencer votre recherche en toute sérénité ?
                        </h2>
                        <p style={{ color: 'black', fontSize: isSmallMobile ? '13px' : '14px', lineHeight: '1.8', margin: 0, maxWidth: '340px' }}>
                            Rejoignez une communauté de musulmans sérieux et faites le premier pas vers une union bénie.
                        </p>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : 'flex-start', gap: '16px', flexShrink: 0 }}>
                        <button onClick={() => navigate('/register')} style={{ padding: isSmallMobile ? '12px 14px' : '14px 18px', backgroundColor: '#4a0028', color: 'white', border: '0.5px solid #8a1e4e', borderRadius: '8px', fontSize: isSmallMobile ? '13px' : '14px', cursor: 'pointer', fontWeight: '400', display: 'inline-flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
                            <FaUser size={13} /> Créer un compte gratuitement
                        </button>
                        <p style={{ color: 'black', fontSize: '13px', margin: 0 }}>
                            Déjà membre ?{' '}
                            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/login'); }} style={{ color: 'black', textDecoration: 'underline', fontWeight: '600', cursor: 'pointer' }}>
                                Se connecter
                            </a>
                        </p>
                    </div>
                </div>
            </section>

            {/* ═══════════ FOOTER ═══════════ */}
            <Footer />

        </div>
    );
};

const styles = {
    container: { fontFamily: 'Arial, sans-serif', overflowX: 'hidden' },
};

export default About;